import React, {useMemo} from "react";
import styles from "./PickADay.module.css";
import {PickADayWeekDay} from "./PickADayWeekDay";
import {type Locale, weeksNames} from "./text.i18n";

interface PickADayWeekProps {
    locale: Locale;
}

export const PickADayWeek: React.FC<PickADayWeekProps> = ({locale}) => {
    const weeksNamesList: string[] = useMemo(() => Object.keys(weeksNames).map(item => weeksNames[item][locale]), [locale]);

    return (
        <div className={styles.PickADay__week}>
            {
                weeksNamesList.map(
                    (item, id) => <PickADayWeekDay key={item} item={item} id={id}/>
                )
            }
        </div>
    )
}